import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import FormikInput from 'components/formikFields/input'
import { toast } from 'react-toastify'
import CustomButton from 'components/customButtons/primary'
import { errorTypes, messages } from './messages/messages'
import { validationSchemas } from './validationSchema/validationSchemas'
import Header from 'components/headers/bulletins'
import { signPromissory } from 'services/promissory'

const instructions = ['برای امضای دیجیتال نیاز است برنامه امضامی نصب بشه', '']

export const PromissorySign = () => {
    const [showCard, setShowCard] = useState(false)

    return (
        <div className="grow mb-20">
            <Header title="ارسال سند به امضامی" />
            <div className="bg-white rounded p-8">
                <p className="text-justify leading-7 p-3 mb-5 shadow-sm border bg-green-2 rounded w-full">
                    <span className="block">کاربر گرامی:</span>
                    در این مرحله پس از دریافت گواهی امضا از امضامی و صدور پیش
                    نویس سفته٬ با وارد کردن کد ملی و فشردن دکمه ارسال می توانید
                    سند خود را به امضامی ارسال کنید و در اپلیکیشن امضامی برای
                    امضا سند اقدام فرمایید
                </p>
                <Formik
                    initialValues={{
                        idCode: '',
                    }}
                    validationSchema={validationSchemas}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {
                        try {
                            const response = await signPromissory(values)
                            toast.info(response['message'])

                            if (
                                response['message'] ===
                                messages.noActiveCertificate
                            ) {
                                setShowCard(true)
                            }
                        } catch (error: any) {
                            if (error.response) {
                                const firstErrorMessage = Object.values(
                                    error.response.data
                                )[0]
                                toast.error(`${firstErrorMessage}`)
                            } else if (error.request) {
                                toast.error(messages.serverError)
                            } else if (
                                error.message === errorTypes.networkError
                            ) {
                                toast.error(messages.networkError)
                            } else {
                                toast.error(messages.requestFailed)
                            }
                        } finally {
                            setSubmitting(false)
                        }
                    }}
                >
                    {({ handleSubmit, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                            <FormikInput name="idCode" label="شماره ملی" />

                            <div className="mt-3">
                                <CustomButton
                                    label={
                                        isSubmitting
                                            ? 'درحال ارسال...'
                                            : 'ارسال'
                                    }
                                    type="submit"
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
                {showCard && (
                    <div className="bg-green-2 mt-4 p-4 border rounded">
                        <ul>
                            {instructions.map((instruction, index) => (
                                <li key={index} className="m-2">
                                    {instruction}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-4">
                            <a
                                href="https://emza.me/download/emzame.apk"
                                className="bg-green-1 hover:bg-blue-2 text-white font-bold py-2 px-4 rounded inline-block"
                                download
                            >
                                دانلود مستقیم امضامی
                            </a>
                            <a
                                href="https://sibapp.com/applications/Emzame"
                                className="bg-green-1 hover:bg-blue-2 text-white font-bold py-2 px-4 rounded inline-block my-2"
                                download
                                target="_blank"
                            >
                                دانلود امضامی از سیب اپ
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PromissorySign
